(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('MaskingDialogController', MaskingDialogController);

    MaskingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Qinius', 'Masking', 'MessageService',
    'Upload', 'UidService', 'ThemeClassify', '$state'];

    function MaskingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Qinius, Masking, MessageService,
        Upload, UidService, ThemeClassify, $state) {
        var vm = this;

        vm.type = entity.state;
        if(entity.state == 'add'){
            vm.data = {
                themeClassifyId: '',
                provider: 'qiniu',
                type: 'MASK',
                keys: []
            }
        }
        vm.attachments = [];
        vm.imgs = [];
        ThemeClassify.getAllByCondition3({items:[{key: "used", op: "=", value: 'true'},{key: "type", op: "=", value: 'MASK'}]},function (res) {
            if(res.status==200){
                vm.setting = res.data;
            }else{
                MessageService.error(res.message);
                return
            }
        });
        vm.domains = Qinius.getDomain();
        vm.cancel = cancel;
        vm.save = save;
        $q.all([vm.domains.$promise]).then(function(){
            // vm.domains = vm.domains.data;
             $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            if(entity.state != 'add'){
                Masking.get({id: entity.data.id}, function (res) {
                    if(res.status == 200){
                        vm.data = res.data;
                    }else {
                        MessageService.error(res.message);
                    }
                });
            }

        })

       Qinius.get(function (msg) {
            vm.token = msg.token;
        });

        window.updateImgFile = function ($event) {
            $scope.$digest();
            $timeout(function () {
                for(var i=0;i<$event.target.files.length;i++){
                    var file = $event.target.files[i];
                    vm.imgs.push(file.name);
                    fileGet(file);
                }
                function fileGet(file) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);

                    formData.append('key', "clipArt-" + UidService.get());
                    formData.append('token', vm.token);
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            vm.attachments.push({identifier:data.key,fileName:vm.imgs[i]});
                            vm.data.keys.push(data.key);
                        },
                        error: function (request) {
                            MessageService.error("文件上传失败");
                        }
                    });

                }
            });
        }
        $scope.removeFile = function(file,index) {
            vm.attachments.splice(index,1);
            vm.data.keys.splice(index,1);
        };
        $scope.typeSelect = function () {
            for(var i=0; i<vm.setting.length; i++){
                if(vm.setting[i].id == vm.data.themeClassifyId){
                    vm.data.themeClassifyName = vm.setting[i].name;
                }
            }
        }

        function cancel() {
            $uibModalInstance.close();
        }
        function save() {
            if(!vm.data.themeClassifyId){
                MessageService.error("请选择蒙版分类");
                return
            }
            if(!vm.data.seq){
                MessageService.error("请输入排序");
                return
            }
            if(vm.type == 'add'){
                if(vm.data.keys.length == 0){
                    MessageService.error("请选择图片");
                    return
                }
            }
            vm.isSaving = true;
            if (vm.data.id != null) {
                Masking.update(vm.data, onSaveSuccess, onSaveError);
            } else {
                Masking.batchCreateByStore(vm.data, onSaveSuccess, onSaveError);
            }
            function onSaveSuccess (res) {
                if(res.status == 200){
                    MessageService.success("蒙版保存成功");
                    $uibModalInstance.close(res.data);
                    vm.isSaving = false;
                    $state.go("masking", null, { reload: 'masking' });
                }else{
                    MessageService.error(res.message);
                    return
                }
            };

            function onSaveError () {
                MessageService.error("蒙版保存失败");
                vm.isSaving = false;
            };
        }
    }
})();
